export enum CMActionType {
  GET_CONTAINER = 'GET_CONTAINER',
  UPDATE_CONTAINER = 'UPDATE_CONTAINER'
}
